// Wygląd profilu dziecka: motyw (kolory, tło) i avatar. Wspólne dla aplikacji i serwera (walidacja identyfikatorów).
// Sama grafika awatarów jest w src/ui/avatars.ts; tu są tylko identyfikatory i reguły ich poprawności.
// Motyw to grupa wybranego awatara (Neutralne, Dinozaury, Pokémon) — dziecko wybiera awatar, a motyw (kolor przycisku startowego) wynika z grupy.
// Dawne motywy (blocks, creatures) z patcha-28 nie istnieją: profil z takim motywem dostaje neutralny, a nieznany awatar — domyślny awatar motywu.

export const THEMES = ['neutral', 'dino', 'pokemon'] as const;
export type ThemeId = (typeof THEMES)[number];
export const DEFAULT_THEME: ThemeId = 'neutral';

/** Identyfikator awatara: `<zestaw>:<nazwa>`, np. `neutral:fox`. Pusty = domyślny awatar zestawu motywu. */
export const AVATAR_ID = /^[a-z0-9_]{1,16}:[a-z0-9_-]{1,24}$/;

/** Najdłuższe imię (pseudonim) profilu. */
export const PROFILE_NAME_MAX = 20;

export const isTheme = (v: unknown): v is ThemeId => typeof v === 'string' && (THEMES as readonly string[]).includes(v);

/** Poprawny identyfikator awatara albo '' (domyślny); `null` = nieprawidłowy. */
export function cleanAvatarId(v: unknown): string | null {
  if (v === undefined || v === null || v === '') return '';
  return typeof v === 'string' && AVATAR_ID.test(v) ? v : null;
}

/** Imię profilu: bez znaków sterujących i nawiasów kątowych, pojedyncze spacje, 1–20 znaków; `null` = nieprawidłowe. */
export function cleanProfileName(v: unknown): string | null {
  if (typeof v !== 'string') return null;
  const t = v.replace(/[\u0000-\u001f\u007f<>]/g, ' ').replace(/\s+/g, ' ').trim();
  if (t === '' || [...t].length > PROFILE_NAME_MAX) return null;
  return t;
}

/** Wygląd profilu zapisany na serwerze i w przeglądarce. */
export interface Look {
  avatar: string;
  theme: ThemeId;
}

export const DEFAULT_LOOK: Look = { avatar: '', theme: DEFAULT_THEME };

/** Wygląd z obcych danych (odpowiedź serwera, pamięć przeglądarki): niepoprawne pola zastępuje domyślnymi. */
export function lookOf(raw: unknown): Look {
  const r = (raw ?? {}) as { avatar?: unknown; theme?: unknown };
  return { avatar: cleanAvatarId(r.avatar) ?? '', theme: isTheme(r.theme) ? r.theme : DEFAULT_THEME };
}
